<template>
	<vue-modal
		:isShowModal="state.isPutModal"
		@close="confirmDelete(data.note?.journal_id)"
		:style="'max-width: 95%'"
		:isLoading="isLoading"
		:isSaving="draftState.isSaving"
	>
		<!-- Journal Types -->
		<template #header
			>{{
				data.note?.status === "block" || data.note?.ref_id > 0
					? `Rediger ${data.terms?.note?.single}`
					: `Opret ${data.terms?.note?.single}`
			}}
			<span style="font-size: 12px">{{ draftInfo }}</span>
		</template>
		<template #minimize>
			<a
				@click="
					closeAfterDraftSave = true;
					saveDraft();
					closeModal();
				"
			>
				<font-awesome-icon
					icon="fa-solid fa-dash"
					class="close"
					height="1rem"
				></font-awesome-icon>
			</a>
		</template>
		<template #body>
			<VeeForm v-if="data" @submit="onSave">
				<Transition name="fade">
					<template v-if="Object.keys(success).length">
						<ul class="form-group alert alert-success">
							<li v-for="(message, key) in success" :key="key">
								{{ message }}
							</li>
						</ul>
					</template>
				</Transition>
				<template v-if="Object.keys(errors).length">
					<ul class="col-md-12 alert alert-danger" id="error_div">
						<li v-for="(message, field) in errors" :key="field">
							{{ message }}
						</li>
					</ul>
				</template>
				<div class="form-body">
					<div
						:class="
							isGrid &&
							gridThreshold &&
							props.store?.user?.userType !== 'student'
								? 'journal-create-grid'
								: null
						"
						:style="
							studentInfoBox !== ''
								? { gridTemplateColumns: '66.6667%' }
								: { gridTemplateColumns: '100%' }
						"
					>
						<div class="item1 row">
							<div
								ref="noteSectionRef"
								class="col"
								style="height: fit-content"
								:style="
									!isGrid && !gridThreshold
										? { minWidth: '66.6667%' }
										: null
								"
							>
								<template
									v-if="
										props.store?.user?.userType !==
										'student'
									"
								>
									<div
										v-for="(type, index) in data.types"
										:key="index"
										style="margin-bottom: 8px"
									>
										<template
											v-if="
												((type.id === 3
													? permissionModule.hasPermission(
															'is_confidential_journal',
														)
													: true) &&
													type.active === 1) ||
												data.note?.type?.id === type.id
											"
										>
											<div
												class="col p-0 d-flex align-items-center"
											>
												<Field
													v-slot="{ field }"
													name="type"
													:value="type.id"
												>
													<label
														class="customcheck pr-1"
													>
														<input
															v-bind="field"
															:id="index"
															v-model="
																journalType
															"
															name="type"
															:value="type.id"
															type="radio"
															@input="changeType"
														/>
														<div
															class="checkmark"
														/>
													</label>
												</Field>
												<label
													v-if="type.default"
													class="text-nowrap black"
													style="
														color: #2b335e !important;
													"
													:for="index"
												>
													{{
														type.id === 1
															? "Pædagogisk "
															: type.id === 2
																? "Sundhedsfagligt "
																: type.id === 3
																	? "Fortroligt "
																	: ""
													}}
													{{
														data.terms?.note?.single
													}}
												</label>
												<label
													v-else
													class="text-nowrap"
													style="
														color: #2b335e !important;
													"
													>{{ type.name }}</label
												>
											</div>
										</template>
									</div>
								</template>
								<div
									style="
										display: grid;
										grid-template-columns: 1fr 1fr;
										column-gap: 1rem;
									"
								>
									<div
										class="form-group d-flex"
										style="
											flex-direction: column;
											justify-content: flex-end;
										"
									>
										<Category-Select
											v-if="
												data.studentOptions.some(
													(option) =>
														option.hasOwnProperty(
															'category_id',
														),
												)
											"
											name="student"
											:placeholder="`Vælg ${data.terms?.student?.single}`"
											v-model="student"
											:options="data.studentOptions"
											:selectable="filteredStudents"
											@option:selected="onStudentUpdate"
										></Category-Select>
										<Select
											v-else
											name="student"
											:placeholder="`Vælg ${data.terms?.student?.single}`"
											v-model="student"
											:options="data.studentOptions"
											:selectable="filteredStudentsNoDep"
											@option:selected="onStudentUpdate"
										></Select>
									</div>
									<div
										class="form-group"
										v-if="
											props.store?.user?.userType !==
											'student'
										"
									>
										<label>Gældende:</label>
										<date-picker
											v-model="jouralDate"
											:disableFutureDates="true"
											:enableTime="true"
										/>
									</div>
									<div class="form-group" v-if="journalType">
										<Select
											ref="headlineSelect"
											searchable
											name="category"
											v-model="category"
											:reduce="(category) => category"
											:options="data.categoryOptions"
											:selectable="filteredCategories"
											@option:selecting="changeHeadline"
										/>
									</div>
									<div
										class="form-group"
										v-else-if="
											props.store?.user?.userType ===
											'student'
										"
									>
										<Select
											ref="headlineSelect"
											searchable
											name="category"
											v-model="category"
											:reduce="(category) => category"
											:options="data.categoryOptions"
											:selectable="filteredCategories"
											@option:selecting="changeHeadline"
										/>
									</div>
									<div
										class="form-group"
										v-if="
											journalType &&
											props.store?.user?.userType !==
												'student'
										"
									>
										<MultiSelect
											searchable
											:placeholder="`Vælg ${
												journalType === 2
													? 'målepunkter'
													: 'temaer'
											}`"
											name="themes"
											v-model="themes"
											:options="data.themeOptions"
											:selectable="filteredThemes"
											:reduce="(theme) => theme"
										></MultiSelect>
									</div>
									<div
										class="form-group"
										v-if="
											journalType &&
											permissions.isPlanModule
										"
										v-show="isShowPlans"
									>
										<Select
											searchable
											name="plan"
											v-model="plan"
											:options="data.planOptions"
											:selectable="filteredPlans"
											:reduce="(plan) => plan"
											@option:selected="planChanged"
										></Select>
									</div>
									<div
										class="form-group"
										v-if="
											journalType &&
											permissions.isDataRegistrationModule
										"
										v-show="isShowTemplates"
									>
										<Select
											searchable
											name="template"
											v-model="template"
											:options="data.templateOptions"
											:selectable="filteredTemplates"
											:reduce="(template) => template"
											@option:selected="templateChanged"
										></Select>
									</div>
								</div>
								<base-textarea-group
									v-if="
										subCategoriesAnswers?.length === 0 &&
										plan?.option === 0
									"
									:style="{ minHeight: '18.7rem' }"
									v-model="journalNote"
									name="journalNote"
									:col-input="12"
									:placeholder="`${data.terms?.note?.single_cap}`"
								>
								</base-textarea-group>
							</div>
							<div
								class="col"
								v-if="
									studentInfoBox !== '' &&
									!isGrid &&
									!gridThreshold &&
									props.store?.user?.userType !== 'student'
								"
							>
								<div
									class="form-group student-info-box custom-scrollbar"
									:style="{ height: studentInfoBoxHeight }"
								>
									<p
										class="p-1"
										style="white-space: break-spaces"
										v-html="
											studentInfoBox
												? studentInfoBox
												: `<i>Der er ikke tilføjet tekst under ${data.terms?.journalCompose.single}informationer på profilen</i>`
										"
									></p>
								</div>
							</div>
						</div>
						<div class="item3 row" ref="item3Ref">
							<div class="col">
								<div
									v-for="(
										field, index
									) in subCategoriesAnswers"
									:key="index"
								>
									<label
										class="text-decoration-underline font-bold"
										style="
											margin-bottom: 7.5px;
											color: #2b335e;
										"
										:for="field.templates_id"
										>{{ field.headlinetext }}</label
									>
									<Field
										:name="`subCategoriesAnswers[${field.templates_id}]`"
										:value="field.answer"
									>
										<template v-slot="{ field: fieldObj }">
											<base-textarea-group
												v-bind="fieldObj"
												:style="{ minHeight: '12rem' }"
												v-model="field.answer"
												:name="`subCategoriesAnswers[${field.templates_id}]`"
												:col-input="12"
												:placeholder="field.helptext"
											></base-textarea-group>
										</template>
									</Field>
								</div>
								<Plan
									v-if="selectedPlan"
									:plan="selectedPlan"
									:journalAnswers="data.note?.answers"
									@answers="getPlanAnswers"
								/>
								<Field
									hidden
									name="planData"
									:model-value="selectedPlan"
								/>
								<TemplateHelperInput
									:isJournal="true"
									:isEdit="true"
									:isDateChange="false"
									:isPreview="false"
									:isRegister="false"
									v-if="
										Object.keys(selectedTemplate).length > 0
									"
									@answers="getTemplateAnswers"
									:template="selectedTemplate"
									:templateHistory="
										data.note?.data_registration
									"
								/>
								<Field
									hidden
									name="templateData"
									:model-value="selectedTemplate"
								/>
							</div>
						</div>
						<div
							:class="isGrid && gridThreshold ? 'pl-1' : null"
							class="item2"
							v-if="
								studentInfoBox !== '' &&
								isGrid &&
								props.store?.user?.userType !== 'student'
							"
						>
							<div
								class="form-group student-info-box custom-scrollbar"
								:style="{ height: studentInfoBoxHeight }"
							>
								<p
									class="p-1"
									style="white-space: break-spaces"
									v-html="
										studentInfoBox
											? studentInfoBox
											: `<i>Der er ikke tilføjet tekst under ${data.terms?.journalCompose.single}informationer på profilen</i>`
									"
								></p>
							</div>
						</div>
					</div>
					<div class="separator form-group" />
					<div
						ref="buttonRow"
						class="d-flex justify-content-end"
						style="column-gap: 1rem"
					>
						<button
							hidden
							v-if="data.note?.journal_id"
							class="btn btn-deletion"
							type="button"
							@click.prevent="deleteDraft(data.note.journal_id)"
						>
							Slet
						</button>
						<button hidden data-type="draft" class="btn btn-draft">
							Gem som kladde
						</button>
						<button
							data-type="active"
							id="putModalSaveButton"
							class="btn btn-primary"
							style="visibility: visible"
						>
							Publicer
						</button>
					</div>
				</div>
			</VeeForm>
		</template>
	</vue-modal>
</template>

<script setup>
import DatePicker from "@elements/datePicker/DatePicker.vue";
import BaseTextareaGroup from "@elements/form/BaseTextareaGroup.vue";
import vueModal from "@elements/form/vueModal.vue";
import MultiSelect from "@elements/select/BaseMultiSelect.vue";
import Select from "@elements/select/BaseSingleSelect.vue";
import CategorySelect from "@elements/select/CategorySingleSelect.ce.vue";
import permissionModule from "@helpers/PermissionHelper";
import { terms } from "@helpers/TermHelper";
import TemplateHelperInput from "@helpers/templates/templateHelperInput.vue";
import CategoryService from "@services/CategoryService";
import DepartmentService from "@services/DepartmentService";
import JournalService from "@services/JournalService";
import PlanService from "@services/PlanService";
import StudentMetaService from "@services/StudentMetaService";
import StudentService from "@services/StudentService";
import TemplateService from "@services/TemplateService";
import ThemeService from "@services/ThemeService";
import TypeService from "@services/TypeService";
import UserService from "@services/UserService";
import { differenceInMinutes, format, formatDistance } from "date-fns";
import Swal from "sweetalert2";
import {
	Field,
	Form as VeeForm,
	configure,
	useField,
	useForm,
	useValidateField,
} from "vee-validate";
import { computed, onMounted, ref, watch, watchEffect } from "vue";
import Plan from "../../plan/planData.vue";
const service = new JournalService();
const metaService = new StudentMetaService();
const planService = new PlanService();
const templateService = new TemplateService();
const typeService = new TypeService();

const props = defineProps({
	data: Object,
	state: Object,
	store: Object,
});

const data = ref(
	{
		studentOptions: props.data.studentOptionsWithDeps || [],
		departmentOptions: props.data.departmentOptions || [],
		categoryOptions: [
			{
				label: "Vælg overskrift",
				option: 0,
			},
		],
		themeOptions: props.data.themeOptions || [],
		planOptions: [
			{
				label: "Vælg plan",
				option: 0,
			},
		],
		templateOptions: [
			{
				label: "Vælg dataregistreringsskabelon",
				option: 0,
			},
		],
		note: props.data.note || {},
		types: props.data.types || [],
		categories: props.data.categories || [],
		themes: props.data.themes || [],
		plans: props.data.plans || [],
		templates: props.data.templates || [],
		users: props.data.users || [],
		studentId: props.data.studentId,
		terms: props.data.terms || {},
		departments: props.data.departments || [],
	},
	props.data,
);

const isLoading = ref(true);

const permissions = ref([
	{
		isDataRegistrationModule: false,
	},
	{
		isPlanModule: false,
	},
]);

const getIsDataregistrationModule = async () => {
	permissions.value.isDataRegistrationModule =
		await permissionModule.hasModule("data_registration_module");
};
const getIsPlanModule = async () => {
	permissions.value.isPlanModule =
		await permissionModule.hasModule("measurement_module");
};

configure({
	validateOnBlur: false,
	validateOnChange: false,
	validateOnInput: false,
});

const { errors, validate } = useForm();

// Student stuff
const { value: student } = useField(
	"student",
	(value) => {
		if (value && !value?.category_id && data.value.departments.length > 1) {
			return `Vælg venligst en ${data.value.terms?.department.single} for ${data.value.terms?.student?.single_specific}, før du opretter et ${data.value.terms?.note?.single}`;
		} else if (!value) {
			return `Vælg venligst ${data.value.terms?.student?.single}`;
		}
		return true;
	},
	{
		syncVModel: true,
		validateOnValueUpdate: false,
	},
);

const { value: journalType } = useField(
	"type",
	(value) => {
		if (props.store?.user?.userType === "student") {
			return true;
		}
		if (!value) {
			return `Vælg venligst ${data.value.terms?.note?.single}type`;
		}
		return true;
	},
	{
		initialValue: data.value.note?.type?.id,
		validateOnValueUpdate: false,
	},
);

// Student stuff end

// journalNote stuff

const { value: journalNote, setErrors: setNoteErrors } = useField(
	"journalNote",
	(value) => {
		if (!value && props.store?.user?.userType !== "student") {
			if (
				(category.value?.option === 0 && plan.value?.option === 0) ||
				(category.value?.option &&
					subCategoriesAnswers.value?.length === 0)
			) {
				return `Skriv venligst et ${data.value.terms?.note?.single}`;
			}
		}
		return true;
	},
	{
		initialValue: data.value.note?.information,
		validateOnValueUpdate: false,
	},
);

// journalNote stuff end

// Category stuff

const { value: category } = useField(
	"category",
	(value) => {
		if (props.store?.user?.userType === "student" && value?.option === 0) {
			return `Vælg venligst en overskrift`;
		}
		return true;
	},
	{
		syncVModel: true,
		validateOnValueUpdate: false,
	},
);

const subCategories = ref([]);

const { value: subCategoriesAnswers, setErrors: setCategoryErrors } = useField(
	"subCategoriesAnswers",
	(values) => {
		if (values.length > 0) {
			const some = values.some((value) => value.answer !== "");
			if (!some) {
				return `Skriv venligst et ${data.value.terms?.note?.single}`;
			}
		}
		return true;
	},
	{
		initialValue: [],
		validateOnValueUpdate: false,
	},
);

// Dynamic info box height
const noteSectionRef = ref(null);
const studentInfoBoxHeight = ref("25rem");
const item3Ref = ref(null);
const gridThreshold = ref(true);
const observeHeight = () => {
	const noteSection = noteSectionRef.value;
	const item3 = item3Ref.value;
	if (!noteSection) return;

	const resizeObserver = new ResizeObserver(() => {
		const width = window.innerWidth;
		const noteSectionHeight = noteSection.offsetHeight;
		const item3Height = item3.offsetHeight;
		if (isGrid.value && width > 633) {
			gridThreshold.value = true;
			studentInfoBoxHeight.value = `${noteSectionHeight + item3Height - 11}px`;
		} else {
			gridThreshold.value = false;
			if (width > 492) {
				studentInfoBoxHeight.value = `${noteSectionHeight - 21}px`;
			} else {
				studentInfoBoxHeight.value = "";
			}
		}
	});

	resizeObserver.observe(noteSection);
	resizeObserver.observe(item3);
};
watch(noteSectionRef, () => {
	if (props.store?.user?.userType !== "student") {
		observeHeight();
	}
});
const existingAnswers = ref(data.value.note?.answers);
const populateSubCategoriesAnswers = () => {
	subCategoriesAnswers.value = [];
	subCategories.value =
		data.value.categories?.find((cat) => cat.id === category.value.option)
			?.sub_categories || [];
	for (const category of subCategories.value) {
		// Find the existing answer for the subcategory
		const answer = existingAnswers.value?.find(
			(answer) => category.templates_id === answer.template_id,
		);

		// If there is an existing answer, add it to the modified subCategory
		if (answer) {
			subCategoriesAnswers.value.push({
				...category,
				answer: answer.value,
				td_id: answer.td_id,
				headlinetext: answer.headlinetext,
			});
		} else {
			// If there is no existing answer, add the subcategory with an empty answer
			subCategoriesAnswers.value.push({
				...category,
				answer: "",
			});
		}
	}
};

// Category stuff end

// Themes stuff
const { value: themes } = useField(
	"themes",
	(values) => {
		if (values && values.length >= 6) {
			return `Du kan ikke vælge mere end 5 ${
				journalType.value === 2 ? "målepunkter" : "temaer"
			}`;
		}
		return true;
	},
	{
		syncVModel: true,
		validateOnValueUpdate: false,
	},
);

const validateThemes = useValidateField("themes");

// Themes stuff end

const studentInfoBox = ref("");

// Inputs
const jouralDate = ref(
	data.value.note?.joural_date
		? new Date(data.value.note?.joural_date)
		: new Date(),
);

const plan = ref(
	data.value.planOptions.find(
		(option) =>
			option.option === data.value.note?.headline_id &&
			data.value.note.headline_type === "plan",
	) || data.value.planOptions[0],
);
const selectedPlan = ref(null);
const fetchPlan = async () => {
	selectedPlan.value =
		plan.value.option !== 0
			? await planService
					.get(plan.value.option)
					.then((response) => response.data)
			: null;
};
const planAnswers = ref([]);
const getPlanAnswers = (answers) => {
	planAnswers.value = answers;
};

watch(plan, async () => {
	await fetchPlan();
});
const filteredPlans = (option) => {
	const item = data.value.plans.find((plan) => option.option === plan.id);
	return filterBy(item, option, "plan");
};

const template = ref(
	data.value.templateOptions.find(
		(option) => option.option === data.value.note?.data_registration_id,
	) || data.value.templateOptions[0],
);
const templates = ref([]);
const selectedTemplate = ref({});
const templateAnswers = ref({});
const fetchTemplate = async () => {
	selectedTemplate.value = {};
	if (template.value && template.value?.option !== 0) {
		if (
			templates.value.some(
				(option) => option.id === template.value.option,
			)
		) {
			return templates.value.find(
				(templateToFind) => templateToFind.id == template.value.option,
			);
		} else {
			await templateService
				.getTemplate(template.value.option)
				.then((response) => templates.value.push(response));
			return templates.value.find(
				(templateToFind) => templateToFind.id == template.value.option,
			);
		}
	}
	return {};
};

const getTemplateAnswers = (answers) => {
	let ans = JSON.parse(JSON.stringify(answers));

	for (const [key, value] of Object.entries(ans)) {
		if (
			value === null ||
			value === undefined ||
			String(value).trim() === "" ||
			(typeof value === "object" && Object.keys(value).length === 0)
		) {
			delete ans[key];
		}
		if (typeof value === "object" && !Array.isArray(value)) {
			let newValueArr = [];
			if (ans[key] && typeof ans[key] === "object") {
				for (const [key, value] of Object.entries(ans[key])) {
					newValueArr.push(value);
				}
				ans[key] = newValueArr.toString();
			}
		}
	}

	templateAnswers.value = ans;
};

const templateChanged = async () => {
	selectedTemplate.value = await fetchTemplate();
};

const filteredTemplates = (option) => {
	const item = data.value.templates.find(
		(template) => option.option === template.id,
	);
	return filterBy(item, option, "template");
};

// Functionality
const isShowPlans = ref(false);
const isShowTemplates = ref(false);

watch(
	() => [student.value, isLoading.value],
	async ([newStudent, newLoading]) => {
		if (newStudent && !newLoading) {
			const categoryValid = data.value.categories.find(
				(categoryToFind) => {
					const students =
						(categoryToFind.student_ids &&
							categoryToFind.student_ids.split(",")) ||
						[];
					return (
						categoryToFind.id === category.value?.option &&
						(!students ||
							students.length === 0 ||
							students.includes(
								student.value?.option?.toString(),
							))
					);
				},
			);
			if (props.store?.user?.userType === "student") {
				if (
					!props.store?.user?.writableCategories.includes(
						category.value?.option,
					)
				) {
					category.value = data.value.categoryOptions[0];
				}
			}
			if (!categoryValid) {
				category.value = data.value.categoryOptions[0];
			}
			const validPlan = data.value.plans.find((planToFind) => {
				return (
					planToFind.id === plan.value?.option &&
					planToFind.student_id === student.value?.option.toString()
				);
			});
			if (!validPlan) {
				plan.value = data.value.planOptions[0];
			}
			if (
				data.value.plans.some(
					(plan) =>
						plan.student_id === student.value?.option.toString(),
				)
			) {
				isShowPlans.value = true;
			} else {
				isShowPlans.value = false;
			}
			const validTemplate = data.value.templateOptions.find(
				(templateToFind) => {
					return (
						templateToFind.option === template.value?.option &&
						templateToFind.category_id === student.value.category_id
					);
				},
			);
			if (!validTemplate) {
				template.value = data.value.templateOptions[0];
			}
			if (
				data.value.templates.some(
					(template) =>
						template.department_id === student.value?.category_id ||
						(!student.value?.category_id &&
							template.department_id === 0),
				)
			) {
				isShowTemplates.value = true;
			} else {
				isShowTemplates.value = false;
			}
			studentInfoBox.value = await metaService.getBoxData(
				"journal_info",
				newStudent.option,
			);
		}
	},
);

const onStudentUpdate = async () => {
	studentInfoBox.value = await metaService.getBoxData(
		"journal_info",
		student.value?.option,
	);
};
const categoryChanged = (value) => {
	category.value = value;
	if (category.value && category.value.option !== 0) {
		plan.value = data.value.planOptions[0];
	}
	populateSubCategoriesAnswers();
};
const planChanged = () => {
	if (plan.value && plan.value.option !== 0) {
		category.value = data.value.categoryOptions[0];
		subCategoriesAnswers.value = [];
	}
};
const filteredStudents = (option) => option.option !== "" && !option.isCategory;
const filteredStudentsNoDep = (option) => option.option !== "";
const filteredCategories = (option) => {
	if (option.status === "Block") return;
	const item = data.value.categories.find(
		(category) => option.option === category.id,
	);
	return filterBy(item, option, "category");
};
const filteredThemes = (option) => {
	if (option.status === "Block") return;
	const item = data.value.themes.find((theme) => option.option === theme.id);
	return filterBy(item, option, "theme");
};

onMounted(async () => {
	if (props.store?.user?.userType !== "student") {
		observeHeight();
		studentInfoBox.value = await metaService.getBoxData(
			"journal_info",
			data.value.note?.student_id || data.value.studentId,
		);
	}
	if (data.value.note && Array.isArray(data.value.note.data_registration)) {
		data.value.note.data_registration.forEach((item) => {
			if (item.id !== undefined) {
				item.question_id = item.id;
				delete item.id;
			}
			if (item.answer) {
				templateAnswers.value[item.question_id] = item.answer;
			}
		});
	}
	Promise.all([
		fetchUsers(),
		fetchTerms(),
		populateOptions(),
		getIsDataregistrationModule(),
		getIsPlanModule(),
		fetchPlan(),
		fetchTemplate(),
		fetchTypes(),
		fetchCategories(),
		fetchThemes(),
		fetchPlans(),
		fetchTemplates(),
	]).then(() => {
		isLoading.value = false;
	});
});

const getHeadlineType = computed(() => {
	if (selectedPlan.value?.id) return "plan";
	if (category.value?.option !== 0) return "cat headline";
	// if (selectedTemplate.value?.id) return "template";
	else return null;
});

const getHeadlineID = computed(() => {
	if (selectedPlan.value?.id) return selectedPlan.value.id;
	if (category.value?.option !== 0) return category.value.option;
	// if (selectedTemplate.value?.id) return selectedTemplate.value.id;
	else return null;
});

const getTemplateID = computed(() => {
	if (selectedTemplate.value?.id) return selectedTemplate.value.id;
	else return null;
});

const getAnswers = computed(() => {
	if (subCategoriesAnswers.value.length > 0)
		return subCategoriesAnswers.value;
	if (planAnswers.value?.length > 0) return planAnswers.value;
	else return null;
});
const buttonRow = ref(null);
const success = ref({});
const draftState = ref({
	isDraft: false,
	isSaving: false,
	lastSaved: null,
	modified: false,
});

let isSavingInProgress = false;
const saveQueue = [];
const closeAfterDraftSave = ref(false);

const onSave = async () => {
	if (isSavingInProgress) {
		return;
	}
	if (draftState.value.isSaving) {
		saveQueue.push({ isDraft: false });
		return;
	}

	isSavingInProgress = true;

	try {
		// Validate themes if needed
		if (themes.value.length > 0) {
			const { valid: themesValid } = await validateThemes();
			if (!themesValid) {
				return;
			}
		}

		const { valid } = await validate();
		if (!valid) {
			isSavingInProgress = false;
			return;
		}
		const formData = {
			type_id:
				props.store?.user?.userType === "student"
					? null
					: journalType.value,
			joural_date: format(jouralDate.value, "yyyy-MM-dd HH:mm:ss"),
			cat_id: themes.value?.map((theme) => theme.option).toString(),
			student_id: student.value?.option,
			dep_id: student.value?.category_id,
			information: getAnswers.value ? null : journalNote.value,
			headline_id: getHeadlineID.value,
			data_registration_id: getTemplateID.value,
			subCategoriesAnswers: getAnswers.value,
			templateAnswers: templateAnswers.value,
			status: "active",
			headline_type: getHeadlineType.value,
			medicin_treatment_id: props.data.note?.medicin_treatment_id
				? props.data.note?.medicin_treatment_id
				: null,
			last_updated: Math.round(Date.now() / 1000),
			medicin_treatment_id: data.value.note?.medicin_treatment_id ?? null,
		};

		let response;
		if (data.value.note?.journal_id) {
			response = await service.update(
				data.value.note.journal_id,
				formData,
			);
		} else {
			response = await service.create(formData);
		}

		data.value.note = response.data;

		if (response.status === 200 || response.status === 201) {
			success.value.message = `${
				data.value.terms?.note?.single_specific_cap
			} er nu ${props.data.note?.journal_id ? "opdateret" : "publiceret"}`;
			emit("update-drafts");
			setTimeout(() => {
				success.value = "";
				emit("close", response.data.id || response.data.journal_id);
			}, 1000);
		}
	} catch (error) {
		console.log("Error during manual save:", error);
	} finally {
		processQueue();
	}
};

const saveDraft = async () => {
	if (isSavingInProgress) return;
	try {
		// Validate themes if needed
		if (themes.value.length > 0) {
			const { valid: themesValid } = await validateThemes();
			if (!themesValid) {
				draftState.value.isSaving = false;
				return;
			}
		}

		setCategoryErrors([]);
		setNoteErrors([]);

		const formData = {
			type_id:
				props.store?.user?.userType === "student"
					? null
					: journalType.value,
			joural_date: format(jouralDate.value, "yyyy-MM-dd HH:mm:ss"),
			cat_id: themes.value?.map((theme) => theme.option).toString(),
			student_id: student.value?.option,
			dep_id: student.value?.category_id,
			information: getAnswers.value ? null : journalNote.value,
			headline_id: getHeadlineID.value,
			data_registration_id: getTemplateID.value,
			subCategoriesAnswers: getAnswers.value,
			templateAnswers: templateAnswers.value,
			status: "draft",
			headline_type: getHeadlineType.value,
			last_updated: Math.round(Date.now() / 1000),
			medicin_treatment_id: data.value.note?.medicin_treatment_id ?? null,
		};

		let response;
		if (data.value.note?.journal_id) {
			response = await service.update(
				data.value.note.journal_id,
				formData,
			);
		} else {
			response = await service.create(formData);
		}

		if (response.status === 208) {
			data.value.note.journal_id = response.journal_id;
		} else {
			data.value.note = response.data;
		}

		if (response.status === 200 || response.status === 201) {
			draftState.value.isDraft = false;
			draftState.value.isSaving = false;
			draftState.value.lastSaved = new Date();
			emit("update-drafts");
		}
	} catch (error) {
		console.log("Error during draft save:", error);
	} finally {
		draftState.value.isSaving = false;
		processQueue();
	}
};

const processQueue = async () => {
	if (
		isSavingInProgress ||
		draftState.value.isSaving ||
		saveQueue.length === 0
	) {
		return;
	}

	const { isDraft } = saveQueue.shift();

	try {
		if (isDraft) {
			await saveDraft();
		} else {
			await onSave();
		}
	} finally {
		processQueue(); // Continue processing the queue recurively
	}
};

const filterBy = (item, option, type) => {
	if (props.store?.user?.userType === "student") {
		if (type === "category") {
			return (
				props.store?.user?.writableCategories?.includes(
					option.option,
				) || option.option === 0
			);
		} else {
			return false;
		}
	}
	const currentUser = data.value.users.find(
		(user) => user.user_id === current_user_id,
	);
	const userDepartments = currentUser?.department_ids?.split(",") || [];
	const studentDepartment = student.value?.category_id?.toString();
	const selectedStudent = student.value?.option?.toString();

	if (type === "plan") {
		const planJournalTypes =
			option.journalNoteTypes !== undefined &&
			option.journalNoteTypes !== null
				? option.journalNoteTypes.split(",")
				: [];
		return (
			(item?.student_id === selectedStudent &&
				item?.status === 1 &&
				(planJournalTypes.includes(String(journalType.value)) ||
					planJournalTypes === undefined ||
					planJournalTypes.length === 0)) ||
			option.option === 0
		);
	} else if (type === "template") {
		return (
			((userDepartments.includes(item?.department_id.toString()) ||
				userDepartments.includes("all") ||
				currentUser.user_type == "sa") &&
				studentDepartment == item?.department_id.toString()) ||
			(!studentDepartment && !item?.department_id) ||
			option.option === 0
		);
	} else if (type === "theme") {
		return option?.type_id === journalType.value && !option.deleted;
	} else if (type === "category") {
		const departments = item?.dep_ids
			? item?.dep_ids?.split(",")
			: [] || [];
		const students =
			item?.student_ids?.split(",").filter((student) => student !== "") ||
			[];

		let includesStudentDep =
			departments.length === 0 ||
			departments.some(
				(department) =>
					studentDepartment === department ||
					studentDepartment == "all",
			);
		let includesUserDep =
			departments.length === 0 ||
			departments.some(
				(department) =>
					userDepartments?.includes(department) ||
					userDepartments == "all",
			);
		let includesStudent =
			students.length === 0 || students?.includes(selectedStudent);
		return (
			(option?.type_id === journalType.value &&
				includesStudentDep &&
				includesUserDep &&
				includesStudent &&
				!option.deleted) ||
			option.option === 0
		);
	} else {
		console.log("oh no, unhandled scenario");
	}
};
const fetchTerms = async () => {
	data.value.terms = await terms();
};
const getDepartments = async () => {
	if (!props.data.departments) {
		const departmentService = new DepartmentService();
		data.value.departments = await departmentService.getAll();
	}
};
const filteredStudentOptions = ref([]);
const populateOptions = async () => {
	if (!props.data.studentOptions) {
		await getDepartments();
		const service = new StudentService();
		let students =
			props.store.user?.userType === "student"
				? [await service.get(props.store.user?.id)]
				: await service.getAll();
		if (data.value.studentId) {
			students = students.filter(
				(student) => student.student_id === data.value.studentId,
			);
		}
		students.forEach(async (student) => {
			const departmentIDs =
				student.department_ids !== "all"
					? student.department_ids.split(",")
					: [];
			if (data.value.departments?.length > 0) {
				if (departmentIDs.length === 0) {
					const option = {
						label: `${student?.fname} ${student?.lname}`,
						option: student.student_id,
					};
					data.value.studentOptions.push(option);
					filteredStudentOptions.value.push(option);
				} else {
					departmentIDs.forEach(async (id) => {
						const department = data.value.departments.find(
							(department) => department.dep_id === parseInt(id),
						);
						const option = {
							label: `${student?.fname} ${student?.lname}`,
							option: student.student_id,
							category: department?.dep_name,
							category_id: department?.dep_id,
						};
						data.value.studentOptions.push(option);
						if (
							!filteredStudentOptions.value.some(
								(opt) => opt.option == option.option,
							)
						) {
							filteredStudentOptions.value.push(option);
						}
					});
				}
			} else {
				const option = {
					label: `${student?.fname} ${student?.lname}`,
					option: student.student_id,
				};
				data.value.studentOptions.push(option);
				filteredStudentOptions.value.push(option);
			}
		});
	}
	if (data.value.note.student_id) {
		student.value = data.value.studentOptions?.find(
			(option) =>
				option.option == data.value.note.student_id &&
				(option.category_id === data.value.note?.dep_id ||
					data.value.note?.dep_id === null),
		);
	} else if (data.value.studentId) {
		const studentDepartmentPairs = data.value.studentOptions.filter(
			(option) => option.option === data.value.studentId,
		);
		student.value =
			studentDepartmentPairs.length === 1
				? studentDepartmentPairs[0]
				: null;
	}
};
const fetchTypes = async () => {
	if (!props.data.types) {
		data.value.types = await typeService
			.getAll()
			.then((response) => response.data);
	}
};
const fetchCategories = async () => {
	if (!props.data.categoryOptions) {
		const categoryService = new CategoryService();
		data.value.categories = await categoryService
			.getActive()
			.then((response) => response.data);
		const sortedCategories = data.value.categories.sort((a, b) => {
			if (a.cat_name < b.cat_name) return -1;
			if (a.cat_name > b.cat_name) return 1;
			return 0;
		});
		sortedCategories.forEach((entry) => {
			const option = {
				label: entry.cat_name,
				option: entry.id,
				type_id: entry.journal_type_id,
				status: entry.status,
			};
			data.value.categoryOptions.push(option);
		});
	} else {
		data.value.categoryOptions = data.value.categoryOptions.concat(
			props.data.categoryOptions.filter((option) => option.option !== 0),
		);
	}
	category.value =
		data.value.categoryOptions.find(
			(option) =>
				option.option === data.value.note?.headline_id &&
				(data.value.note.headline_type === "cat headline" ||
					data.value.note.headline_type === "health terms headline"),
		) || data.value.categoryOptions[0];

	subCategories.value =
		data.value.categories?.find((cat) => cat.id === category.value.option)
			?.sub_categories || [];

	populateSubCategoriesAnswers();
};
const fetchThemes = async () => {
	if (!props.data.themeOptions) {
		const themeService = new ThemeService();
		data.value.themes = await themeService
			.getAll()
			.then((response) => response.data);
		const sortedThemes = data.value.themes.sort((a, b) => {
			if (a.name < b.name) return -1;
			if (a.name > b.name) return 1;
			return 0;
		});
		sortedThemes.forEach((entry) => {
			const option = {
				label: entry.name,
				option: entry.id,
				type_id: entry.journal_type_id,
				status: entry.status,
			};
			data.value.themeOptions.push(option);
		});
	}
	themes.value =
		data.value.themeOptions.filter((option) =>
			data.value.note?.cat_id
				?.split(",")
				.includes(option.option.toString()),
		) || null;
};
const fetchPlans = async () => {
	if (!props.data.planOptions) {
		data.value.plans = await planService
			.getAll()
			.then((response) => response.data);
		const sortedPlans = data.value.plans.sort((a, b) => {
			if (a.plans_title < b.plans_title) return -1;
			if (a.plans_title > b.plans_title) return 1;
			return 0;
		});
		sortedPlans.forEach((entry) => {
			const option = {
				label: entry.plans_title,
				option: entry.id,
				status: entry.status,
				journalNoteTypes: entry.journal_type_ids,
			};
			data.value.planOptions.push(option);
		});
	} else {
		const transformedOptions = props.data.planOptions.map((option) => ({
			...option,
			status: option.status === "active" ? 1 : 0,
		}));
		data.value.planOptions = data.value.planOptions.concat(
			transformedOptions.filter((option) => option.option !== 0),
		);
	}
	plan.value =
		data.value.planOptions.find(
			(option) =>
				option.option === data.value.note?.headline_id &&
				data.value.note.headline_type === "plan",
		) || data.value.planOptions[0];
};
const fetchTemplates = async () => {
	if (!props.data.templateOptions) {
		await getDepartments();
		data.value.templates = await templateService
			.getTemplates({ status: "published", hide: "0", journal: "1" })
			.then((response) => response.data);
		const sortedTemplates = data.value.templates.sort((a, b) => {
			if (a.title < b.title) return -1;
			if (a.title > b.title) return 1;
			return 0;
		});
		sortedTemplates.forEach(async (entry) => {
			const dep = data.value.departments.find(
				(dep) => dep.dep_id === entry.department_id,
			);
			const option = {
				label: entry.title,
				option: entry.id,
				category: dep?.dep_name,
				category_id: dep?.dep_id,
				tempStartDate: entry.updated_at,
			};
			data.value.templateOptions.push(option);
		});
	} else {
		data.value.templateOptions = data.value.templateOptions.concat(
			props.data.templateOptions.filter((option) => option.option !== 0),
		);
	}
	template.value =
		data.value.templateOptions.find(
			(option) => option.option === data.value.note?.data_registration_id,
		) || data.value.templateOptions[0];
	if (template.value && template.value.option !== 0) {
		selectedTemplate.value = await fetchTemplate();
	}
};
const fetchUsers = async () => {
	if (!props.data.users) {
		const userService = new UserService();
		data.value.users = await userService
			.getAll()
			.then((response) => response);
	}
};

function debounce(func, wait) {
	let timeout;
	return function (...args) {
		clearTimeout(timeout);
		timeout = setTimeout(() => func.apply(this, args), wait);
	};
}

function closeModal() {
	if (
		draftInfo.value != "(Gemmer...)" &&
		!draftState.value.isSaving &&
		closeAfterDraftSave.value
	) {
		emit("close");
	}
}

watch(
	() => draftState.value.isSaving,
	() => {
		if (
			draftInfo.value == "(Gemt)" &&
			!draftState.value.isSaving &&
			closeAfterDraftSave.value
		) {
			setTimeout(() => {
				emit("close");
			}, 500);
		}
	},
);

const debouncedOnSave = debounce(saveDraft, 1500); // Adjust the debounce delay as needed
watch(
	() => [
		isLoading.value,
		student.value,
		journalType.value,
		jouralDate.value,
		journalNote.value,
		category.value,
		subCategoriesAnswers.value,
		templateAnswers.value,
		planAnswers.value,
		themes.value,
	],
	async () => {
		if (
			!isLoading.value &&
			category.value != data.value.categoryOptions[0]
		) {
			draftState.value.isDraft = true;
			draftState.value.isSaving = true;
			draftState.value.modified = true;
			debouncedOnSave();
		}
	},
	{ deep: true },
);
const draftInfo = computed(() => {
	if (data.value.note?.journal_id) {
		let header;
		if (draftState.value.isSaving) {
			// If the document is currently saving
			header = "(Gemmer...)";
		} else if (
			draftState.value.lastSaved &&
			differenceInMinutes(
				new Date(),
				new Date(draftState.value.lastSaved),
			) >= 2
		) {
			// If the document was last saved more than 2 minutes ago, display the last saved time
			const lastSavedMessage = `Sidst gemt: ${formatDistance(
				new Date(draftState.value.lastSaved),
				new Date(),
				{
					addSuffix: true,
				},
			)}`;
			header = `(${lastSavedMessage})`;
		} else if (!draftState.value.modified) {
			// If the document is opened but not yet modified
			let lastChangedDate = Date.parse(data.value.note?.last_updated);
			header = `(Sidst ændret: ${format(lastChangedDate, "eeee")} den ${format(lastChangedDate, "d. MMMM yyyy")}, kl. ${format(lastChangedDate, "HH.mm")})`;
		} else {
			// If the document was saved less than 2 minutes ago
			header = "(Gemt)";
		}

		return header;
	}
	return "";
});
const confirmDelete = (id) => {
	if (id) {
		new Swal({
			title: `Du er i gang med at forlade denne pop-up uden at publicere ændringerne.`,
			text: "Er du sikker?",
			icon: "error",
			showCancelButton: true,
			showDenyButton: true,
			reverseButtons: true,
			cancelButtonText: "Annuller",
			denyButtonText: "Publicer ikke",
			confirmButtonText: "Publicer",
			customClass: {
				confirmButton: "btn-bluedesign",
				denyButton: "btn-deletion",
				cancelButton: "btn-greendesign",
			},
		}).then(async (result) => {
			if (result.isConfirmed) {
				draftState.value.isDraft = false;
				data.value.note.status = "active";
				onSave();
				setTimeout(() => {
					emit("close");
				}, 1500);
			} else if (result.isDenied) {
				deleteDraft(id);
			}
		});
	} else {
		emit("update-drafts");
		emit("close");
	}
};

const deleteDraft = async (id) => {
	service.deleteDraft(id).then(() => {
		emit("update-drafts");
		setTimeout(() => {
			emit("close");
		}, 1500);
	});
	window.location.reload();
};
const isGrid = ref(true);
watchEffect(() => {
	if (category.value?.option !== 0) {
		isGrid.value = true;
	} else {
		isGrid.value = false;
	}
});
const headlineSelect = ref(null);
const oldCategory = ref(null);
watch(category, (newValue, oldValue) => {
	oldCategory.value = oldValue;
});
const changeHeadline = (value) => {
	const newCatHasSubHeadlines =
		data.value.categories?.find((cat) => cat.id === value.option)
			?.sub_categories.length > 0 || false;
	if (
		(category.value.option !== 0 &&
			getAnswers.value != null &&
			getAnswers.value?.some(
				(answer) => answer.answer !== "" && answer.answer !== null,
			)) ||
		journalNote.value ||
		(category.value.option === 0 &&
			journalNote.value &&
			newCatHasSubHeadlines)
	) {
		new Swal({
			title: `Du er i gang med at vælge eller ændre en overskrift. Hvis du gør det, vil indholdet gå tabt`,
			text: "Er du sikker?",
			icon: "error",
			showCancelButton: true,
			reverseButtons: true,
			cancelButtonText: "Annuller",
			confirmButtonText: "Ja",
			customClass: {
				confirmButton: "btn-deletion",
				cancelButton: "btn-bluedesign",
			},
		}).then(async (result) => {
			if (result.isConfirmed) {
				journalNote.value = "";
				categoryChanged(value);
			} else {
				category.value = oldCategory.value;
			}
			headlineSelect.value.select.open = false;
		});
	} else {
		journalNote.value = "";
		categoryChanged(value);
	}
};
const oldType = ref(null);
watch(journalType, (newValue, oldValue) => {
	oldType.value = oldValue;
});
const changeType = async (e) => {
	const newType = parseInt(e.target.value);
	if (
		(category.value.option !== 0 &&
			getAnswers.value?.some(
				(answer) => answer.answer !== "" && answer.answer !== null,
			)) ||
		(Array.isArray(themes.value) &&
			themes.value.some(
				(theme) => theme.type_id !== newType && journalType.value !== 3,
			))
	) {
		await new Swal({
			title: `Du er i gang med at ændre journalnotattypen. Hvis du gør det, vil indholdet gå tabt`,
			text: "Er du sikker?",
			icon: "error",
			showCancelButton: true,
			reverseButtons: true,
			cancelButtonText: "Annuller",
			confirmButtonText: "Ja",
			customClass: {
				confirmButton: "btn-deletion",
				cancelButton: "btn-bluedesign",
			},
		}).then(async (result) => {
			if (result.isConfirmed) {
				journalType.value = newType;
			} else {
				journalType.value = oldType.value;
			}
		});
	} else {
		journalType.value = newType;
	}
	if (
		category.value?.type_id &&
		category.value?.type_id !== journalType.value &&
		data.value.note.type.id !== 3
	) {
		category.value = data.value.categoryOptions[0];
		categoryChanged(category.value);
	}
	if (
		Array.isArray(themes.value) &&
		themes.value.some(
			(theme) =>
				theme.type_id !== journalType.value && journalType.value !== 3,
		)
	) {
		themes.value = null;
	}
};
const emit = defineEmits(["close", "update-drafts"]);
</script>
<style>
body {
	color: #6b6f82 !important;
}
</style>
